import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from './Header';
import '../components-css/DeclarationOfFaith.css';
import { setLinkTag, setMetaTag } from '../utils/seo';

const DeclarationOfFaith = () => {
  useEffect(() => {
    const baseUrl = 'https://iglesiacanaldevida.com';
    const pageUrl = `${baseUrl}/declaracion-de-fe`;
    const title = 'Declaración de Fe | Iglesia Canal de Vida';
    const description =
      'Declaración de fe de la Iglesia Canal de Vida en Córdoba, Argentina. Creencias y fundamentos bíblicos de nuestra comunidad.';
    const imageUrl = `${baseUrl}/assets/images/favicons/apple-touch-icon-2.png`;

    document.title = title;
    document.documentElement.setAttribute('lang', 'es-AR');

    setLinkTag('canonical', pageUrl);
    setMetaTag('name', 'description', description);
    setMetaTag('property', 'og:type', 'article');
    setMetaTag('property', 'og:site_name', 'Iglesia Canal de Vida');
    setMetaTag('property', 'og:title', title);
    setMetaTag('property', 'og:description', description);
    setMetaTag('property', 'og:url', pageUrl);
    setMetaTag('property', 'og:image', imageUrl);
    setMetaTag('property', 'og:locale', 'es_AR');
    setMetaTag('name', 'twitter:card', 'summary');
    setMetaTag('name', 'twitter:title', title);
    setMetaTag('name', 'twitter:description', description);
    setMetaTag('name', 'twitter:image', imageUrl);
  }, []);

  return (
    <div className="page-wrapper declaration-page" style={{ position: 'relative', zIndex: 1 }}>
      <Header />
      <section className="declaration-hero">
        <Container>
          <div className="section-title text-center">
            <h1 className="section-title__title">Declaración de Fe Iglesia Canal de Vida</h1>
          </div>
          <div className="declaration-hero__actions">
            <Link className="declaration-hero__link" to="/">
              Volver al inicio
            </Link>
          </div>
        </Container>
      </section>

      <section className="declaration-content">
        <Container>
          <ol className="declaration-list">
            <li className="declaration-item">
              <div className="declaration-item__content">
                <p>
                  Creemos en las Sagradas Escrituras como absoluta fuente de autoridad divina, inspirada por Dios  sin errores en sus  escritos  originales, siendo la Biblia la infalible Palabra de Dios, que rige como única autoridad suprema y final para la fe, la conducta cristiana y la doctrina y práctica de la iglesia.
                  No admitimos otra fuente de autoridad espiritual ó eclesiástica, ni reconocemos como inspirados por Dios los libros apócrifos o deutero canónicos.
                </p>
                <div className="declaration-bible">
                  <span className="declaration-bible__label">Base Bíblica:</span>
                  <span className="declaration-bible__refs">2 Timoteo 3:16-17; 2 Pedro 1:19-21; 1 Tesalonicenses 2:13; Hebreos 4:12-13</span>
                </div>
              </div>
            </li>
            <li className="declaration-item">
              <div className="declaration-item__content">
                <p>
                  Creemos en un solo Dios que existe eternamente en tres  personas: Dios Padre, Dios Hijo y Dios Espíritu Santo; creador y sustentador del universo, todopoderoso, omnipresente, omnisciente, revelado en las Sagradas Escrituras.
                </p>
                <div className="declaration-bible">
                  <span className="declaration-bible__label">Base Bíblica:</span>
                  <span className="declaration-bible__refs">Marcos 12:29; Deuteronomio 4:35; Mateo 3:16-17 y 28:19; 2 Corintios 13:14; Colosenses 1:15-16</span>
                </div>
              </div>
            </li>
            <li className="declaration-item">
              <div className="declaration-item__content">
                <p>
                  Creemos en la deidad del Señor Jesucristo, su nacimiento virginal, su vida sin pecado, su muerte en la cruz, como único sacrificio válido para pagar la pena de nuestros pecados ante la justicia Divina, su resurrección corporal y su exaltación en Gloria a la diestra de Dios.
                </p>
                <div className="declaration-bible">
                  <span className="declaration-bible__label">Base Bíblica:</span>
                  <span className="declaration-bible__refs">San Juan 1:1 y 14; 1 Pedro 1:18-19; 1 Timoteo 2:5-6; 1 Corintios 15:3-4; Marcos 16:19; Isaías 7:14 y 9:6</span>
                </div>
              </div>
            </li>
            <li className="declaration-item">
              <div className="declaration-item__content">
                <p>
                  Creemos que el Espíritu Santo es Dios y posee todos los atributos divinos; es el interprete infalible de la biblia; convence al hombre de pecado para arrepentimiento. Dios al hacernos sus hijos, nos sella y bautiza con el Espíritu Santo, quien hace morada permanente en todo cristiano verdadero y le da poder.-
                </p>
                <div className="declaration-bible">
                  <span className="declaration-bible__label">Base Bíblica:</span>
                  <span className="declaration-bible__refs">
                    Hechos 5:3-4; San Juan 15:26; 1 Corintios 2:12-14; San Juan 16:8-14; Efesios 1:13-14; 1 Corintios 12:13; Romanos 8:9
                    <br />
                    1 Corintios 3:16; Efesios 2:22; Hechos 1:8
                  </span>
                </div>
              </div>
            </li>
            <li className="declaration-item">
              <div className="declaration-item__content">
                <p>
                  Creemos que el hombre fue creado por Dios, a su imagen y semejanza, que su naturaleza quedó afectada por la caída y orientada al mal, siendo culpable ante Dios por su pecado y está bajo condenación, por lo que es incapaz de restaurarse a sí mismo. Sin embargo es objeto del amor de Dios, quien envió a Jesucristo para hacer un sacrificio por toda la humanidad, de manera que todos los que se arrepienten de sus pecados y creen en el Señor Jesús como Salvador, nacen de nuevo y son hechos hijos de Dios, siendo salvos por gracia y para toda la eternidad.-
                </p>
                <div className="declaration-bible">
                  <span className="declaration-bible__label">Base Bíblica:</span>
                  <span className="declaration-bible__refs">
                    Génesis 1:26-27; Romanos 5:12,17-21; Romanos 3:23-26; Romanos 6:23; Romanos 3:10-12; Efesios 2:1-10
                    <br />
                    Juan 3:16; Juan 10:27-29; 1 Juan 5:11-13
                  </span>
                </div>
              </div>
            </li>
            <li className="declaration-item">
              <div className="declaration-item__content">
                <p>
                  Creemos que todos los hijos de Dios son regenerados y bautizados por el Espíritu Santo, siendo incorporados desde ese momento al cuerpo de Cristo que es la iglesia, formando una unidad espiritual, donde Cristo es la cabeza.
                  El objetivo de la iglesia es dar gloria a Dios, que se manifiesta por la actitud, conducta y acción de cada creyente en obediencia a la Palabra de Dios. Cada hijo de Dios debe identificarse con una iglesia local, cumpliendo con sus responsabilidades para mantener la comunión con Dios y con los hermanos, respetando las autoridades vigentes, para juntos trabajar en la gran comisión dada por el Señor.-
                </p>
                <div className="declaration-bible">
                  <span className="declaration-bible__label">Base Bíblica:</span>
                  <span className="declaration-bible__refs">
                    1 Corintios 12:12-13; Efesios 2:19-22; Efesios 1:22-23; Efesios 5:23-27; Efesios 4:1-6; 1 Corintios 1:10
                    <br />
                    Mateo 28:18-20; Marcos 16:15
                  </span>
                </div>
              </div>
            </li>
            <li className="declaration-item">
              <div className="declaration-item__content">
                <p>
                  Creemos que todo hijos de Dios es llamado a una vida de santidad práctica, que honre a Dios, no consintiendo ni participando de comentarios y/o prácticas pecaminosas, que ofendan la santidad de Dios, que afecte su vida o la de otros; comprometiéndose a dar buen testimonio y a servir a Dios en su hogar y en la comunidad, para la gloria de Dios.-
                </p>
                <div className="declaration-bible">
                  <span className="declaration-bible__label">Base Bíblica:</span>
                  <span className="declaration-bible__refs">
                    2 Corintios 5:17; Génesis 39:9b; 1 Pedro 1:14-16; 2 Corintios 6:14-18 y 7:1; 1 Tesalonicenses 4:3-7; 1 Juan 2:15-17; Romanos 13:12-14; Efesios 2:10
                  </span>
                </div>
              </div>
            </li>
          </ol>
        </Container>
      </section>
    </div>
  );
};

export default DeclarationOfFaith;
